import { createSlice } from "@reduxjs/toolkit";
import { emptyAlert } from "../common/AlertNotification";

const initialState = {
  alert: null,
};

const alertNotificationSlice = createSlice({
  name: "alertNotification",
  initialState,
  reducers: {
    setAlert(state, action) {
      state.alert = action.payload;
    },
    clearAlert(state) {
      state.alert = emptyAlert;
    },
  },
});

export const { setAlert, clearAlert } = alertNotificationSlice.actions;
export default alertNotificationSlice.reducer;
